<template>
  <div class="middleWrap">
    <div class="toolbar">
      <span class="spItem ml20">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.fullScreen') }}</span>
          </template>
          <img src="@/assets/design/new_8.png" class="hover" v-if="!fullscreen" @click="$emit('fullscreen')" />
        </a-tooltip>
        <img class="hover" @click="$emit('exitfullscree')" v-if="fullscreen" src="@/assets/design/new_8.png" />
      </span>
      <span class="spItem ml20">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.shortcutKey') }}</span>
          </template>
          <img src="@/assets/design/new_9.png" class="hover" @click="hotKeyVisible = true" />
        </a-tooltip>
      </span>
      <span class="spItem ml20">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.designRecord') }}</span>
          </template>
          <img src="@/assets/design/new_10.png" @click="recordFn()" class="hover" />
        </a-tooltip>
        <div class="recordWrap" :class="{ hover: recordTrue }">
          <div class="rdTop">
            <span>{{ $t('design.recentlyDesignedProducts') }}</span>
            <span
              ><a href="/product/library" target="_blank">{{ $t('generic.viewMore') }}>></a></span
            >
          </div>
          <div class="rdBody clearFix">
            <div class="rdItem" v-for="(item, i) in imgList" :key="i">
              <img width="90" @click="copyProduct(item)" :src="item.show_master_image" alt="图片" />
              <h5 class="tag-read" :data-clipboard-text="item.id" @click="copyFn()">{{ item.id }}</h5>
            </div>
          </div>
          <div style="text-align: center; margin: 15px 0">
            <a-pagination
              simple
              :default-current="1"
              :total="searchCondition.total"
              :current="searchCondition.page"
              :page-size="6"
              @change="
                current => {
                  getOpenMaterialMethod({ per_page: 6, page: current })
                }
              "
            />
          </div>
        </div>
        <div class="recordBg" @click="recordTrue = false" v-if="recordTrue"></div>
      </span>
      <span class="spItem ml20" id="instruWrap">
        <a-popover
          :trigger="['click']"
          :visible="designDescVisible"
          @visibleChange="
            val => {
              visibleChange(val)
            }
          "
          :getPopupContainer="() => document.getElementById('instruWrap')"
        >
          <template slot="content">
            <div>
              <div class="contentWrap">
                <div class="instruTitle">
                  <span :class="{ on: designDescIndex === 0 }" @click="clickDesignDesc(0)">Design tips</span>
                  <span
                    v-if="printImgInfo.design_en_desc"
                    :class="{ on: designDescIndex === 1 }"
                    @click="clickDesignDesc(1)"
                    >Product Design</span
                  >
                </div>
                <div v-if="designDescIndex === 0">
                  <div class="instruTit">1. Safe print & Stitching area</div>
                  <div class="instruImg">
                    <img src="@/assets/design/instru_1.png" />
                  </div>
                  <div class="instruTit">Safe print area</div>
                  <div class="instruP">
                    Keep all your designs are in the safe print area, in case your designs will be lost during
                    production.
                  </div>
                  <div class="instruTit">Stitching area</div>
                  <div class="instruP">
                    This area will be stitched during production. Please make sure your designs are not in this place.
                  </div>
                  <div class="instruTit">2. Get all print area covered</div>
                  <div class="instruImg">
                    <img src="@/assets/design/instru_2.png" />
                  </div>
                  <div class="instruTit">3. Use full-bleed images</div>
                  <div class="instruP">
                    Any space that isn't covered by designs will show the bare fabric, which may destory the design.
                  </div>
                  <div class="instruTit">4. Don't try to match designs across adjacent canvas</div>
                  <div class="instruP">
                    Even though you match designs across adjacent canvas perfectly on a mockup or our 3D model,
                    achieving the perfect design on the finished product is impossible.
                  </div>
                  <div class="instruImg">
                    <img src="@/assets/design/instru_3.png" />
                  </div>
                  <div class="instruTit">5. Logo Safety Area</div>
                  <div class="instruP">
                    It refers to an area to keep your logo which will be printed complete on the apparels, especially
                    some neck labels which are near the stitching area. Click the 'Gridlines' button and see some little
                    squares. Keep your logo at least one square height away from the black line, and then your logo is
                    in the safety area.
                  </div>
                </div>
                <div class="contentBox" v-if="printImgInfo.design_en_desc && designDescIndex === 1">
                  <div class="ql-editor" v-html="printImgInfo.design_en_desc"></div>
                </div>
              </div>
              <div class="tipsWrap" v-if="printImgInfo.design_en_desc">
                <span>
                  <a-checkbox :checked="noPrompt" @change="noPromptChange">
                    Don't Remind
                  </a-checkbox>
                </span>
                <span class="btn hover" @click="visibleChange(false)">Done</span>
              </div>
            </div>
          </template>
          <img src="@/assets/design/new_11.png" class="hover" />
        </a-popover>
      </span>
      <span class="lineSp"></span>
      <span class="spItem">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.revoke') }}</span>
          </template>
          <img
            src="@/assets/design/new_2.png"
            :style="{
              opacity: activeFabric ? (activeFabric.historyRedo.length < 2 ? '0.5' : '1') : '0.5'
            }"
            @click="
              activeFabric.redo(setRandom)
              setCanvasType('')
            "
            class="hover"
          />
        </a-tooltip>
      </span>
      <span class="spItem ml20">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.recovery') }}</span>
          </template>
          <img
            src="@/assets/design/new_3.png"
            :style="{
              opacity: activeFabric ? (activeFabric.historyUndo.length < 1 ? '0.5' : '1') : '0.5'
            }"
            @click="
              activeFabric.undo(setRandom)
              setCanvasType('')
            "
            class="hover"
          />
        </a-tooltip>
      </span>
      <span class="spItem ml20">
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>{{ $t('design.clear') }}</span>
          </template>
          <img
            src="@/assets/design/new_4.png"
            class="hover"
            @click="
              () => {
                resetFabricList()
                setRandom()
                saveHistoryFu()
                setCanvasType('')
              }
            "
          />
        </a-tooltip>
      </span>
    </div>
    <div class="img_level">
      <span>Recommended Pixels: {{ max_px }}</span>
      <span style="margin-left: 20px" v-if="canvasType">{{ getWhSize }}</span>
      <span style="margin-left: 20px" v-if="canvasType">
        Print Quality:
        <b :style="{ color: tipLevel === 0 ? 'green' : tipLevel === 2 ? '#FFA200' : 'red' }">{{
          tipLevel === 0 ? 'High' : tipLevel === 2 ? 'Middle' : 'Low'
        }}</b>
      </span>
    </div>

    <div class="middleMain">
      <!-- <div
        class="gifWrap"
        v-if="gifVisible"
        @click="
          setGifVisible(false)
          $emit('upMenuLeftIndex', 1)
        "
      >
        <img src="@/assets/design/1.gif" />
      </div> -->
      <template
        v-if="
          print_areas.filter(item => {
            return item.view_id === activeDesign && item.design_style
          }).length
        "
      >
        <div class="tip">
          <span class="tipSpan">
            <a-icon class="red" type="info-circle" />
            It is recommended to use hollow out design for this product. The effect of non hollow out design may not be
            good!<a @click="materialVisionMethod()">Try matting</a>
          </span>
        </div>
      </template>
      <template v-else>
        <div class="tip">
          In order to comply with the production specifications, please ensure that the design elements are always
          within the red line!
          <span
            id="tipForImg"
            v-if="tipLevel"
            :style="{ background: tipLevel === 1 ? 'rgb(245, 207, 82)' : tipLevel === 2 ? 'rgb(255, 153, 2)' : 'red' }"
          >
            Picture pixels{{
              tipLevel === 1 ? 'slight deficiency' : tipLevel === 2 ? 'not enough' : 'serious deficiency'
            }}
          </span>
        </div>
      </template>

      <div class="selectPop">
        <div class="sideBox" v-if="print_areas.length !== 1">
          <SyncSide />
        </div>
        <div style="height:calc(100% - 32px);">
          <happy-scroll color="rgba(6,6,13,0.3)" size="5" resize>
            <div style="padding-bottom: 10px; width: 80px">
              <div
                :class="{ imgItem: true, imgItemActive: activeDesign === value.view_id }"
                v-for="(value, index) in bottom_images_template"
                :key="index"
                :style="{ marginRight: index === bottom_images_template.length - 1 ? '30px' : 0 }"
                @click="changeSelect(value.view_id)"
              >
                <a-tooltip placement="left">
                  <template slot="title">
                    <span v-if="value.remark">{{ value.remark }}</span>
                  </template>
                  <img :src="value.image_src" width="100%" height="100%" />
                </a-tooltip>
              </div>
            </div>
          </happy-scroll>
        </div>
      </div>
      <CanvasComponent
        v-for="(value, index) in print_areas"
        :key="value.index"
        :value="value"
        :index="index"
        :fullscreen="fullscreen"
        v-show="value.view_id === activeDesign"
        :configData="configData"
        ref="canvasComponent"
        @upMenuLeftIndex="
          n => {
            $emit('upMenuLeftIndex', n)
          }
        "
        @canvasLoaded="canvasLoaded"
        @upRotatedNum="
          num => {
            $emit('upRotatedNum', num)
          }
        "
      />
    </div>
    <a-modal
      :visible="hotKeyVisible"
      @cancel="
        () => {
          hotKeyVisible = false
        }
      "
      :getContainer="() => document.getElementById('app')"
      width="1000px"
      title="Shortcut key settings"
      :footer="null"
      :destroyOnClose="true"
    >
      <div class="hotKeyModal">
        <div class="hotKeyItem">
          <h5>{{ $t('design.generalOperation') }}</h5>
          <div class="hotKeyBody clearFix">
            <div
              class="bdItem"
              v-for="(value, index) in hotKeys"
              :key="index"
              :class="{ br0: (index + 1) % 3 === 0 && index > 0 }"
            >
              <span>{{ value.name }}</span>
              <span>
                <template v-if="isEdit"
                  ><a-input
                    @keydown="getValue($event, value)"
                    @keyup="keyupFn($event)"
                    @focus="focusFn(value)"
                    @blur="blurFn(value)"
                    style="width: 140px"
                    :placeholder="$t('design.hotkeysPlaceholder')"
                    :value="value.enName"
                  >
                  </a-input>
                </template>
                <template v-else>{{ value.enName }}</template>
              </span>
            </div>
          </div>
        </div>
        <div class="footer-btn">
          <span>
            <a-button v-if="isEdit" @click="regainFn">{{ $t('design.restoreInitialKey') }}</a-button>
          </span>
          <span>
            <template v-if="!isEdit">
              <a-button @click="isEdit = true" type="primary">{{ $t('design.customizeShortcutKeys') }}</a-button>
            </template>
            <template v-else>
              <a-button @click="editCancel" class="mr20">{{ $t('design.cancelSetting') }}</a-button>
              <a-button @click="editSave" type="primary">{{ $t('design.saveSetting') }}</a-button>
            </template>
          </span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { saveHistory } from '@/utils/util'
import CanvasComponent from './canvasComponent'
import * as cc from 'my-design-canvas/desf4fc'
import SyncSide from './syncSide'
import { getOpenMaterial, getProductDesignInfo } from '@/api/productLibrary/index'
import Clipboard from 'clipboard'
import { getUserHotKeys, setUserHotKeys } from '@/api/design'
import { keyCodeData } from '@/utils/const'

export default {
  name: 'MiddleWrap',
  data() {
    return {
      noPrompt: false,
      src: '',
      masks: [],
      imgStyleClose: true,
      groupStyleClose: true,
      maskStyleClose: true,
      groupStyles: [
        { name: '不平铺', type: 0 },
        { name: '基础平铺', type: 1 },
        { name: '纵向交错', type: 3 },
        { name: '横向交错', type: 2 },
        { name: '镜像平铺', type: 4 },
        { name: '随机平铺', type: 5 }
      ],
      searchCondition: {
        total: 1,
        per_page: 6,
        page: 1
      },
      hotKeyVisible: false,
      recordTrue: false,
      imgList: [],
      isEdit: false,
      designDescVisible: false,
      designDescIndex: 0
    }
  },
  computed: {
    ...mapState({
      print_areas: state => state.design.print_areas,
      onePxToRealWidth: state => state.design.onePxToRealWidth,
      printImgInfo: state => state.design.printImgInfo,
      activeDesign: state => state.design.activeDesign,
      syncOtherSide: state => state.design.syncOtherSide,
      fabricList: state => state.design.fabricList,
      tipLevels: state => state.design.tipLevels,
      gifVisible: state => state.design.gifVisible,
      hotKeys: state => state.design.hotKeys,
      initialSize: state => state.design.initialSize,
      getWhSize: state => state.design.getWhSize
    }),
    ...mapGetters([
      'bottom_images_template',
      'activeFabric',
      'activePrintAreas',
      'activeGroupInfo',
      'tipLevel',
      'getCopyProductId',
      'canvasType'
    ]),
    max_px() {
      let str = ''
      const { actual_sizes, dpi } = this.printImgInfo
      if (actual_sizes) {
        let obj = {}
        actual_sizes.forEach(item => {
          if (item.size_id === this.initialSize) {
            obj = item
          }
        })
        this.print_areas.forEach(item => {
          if (item.view_id === this.activeDesign) {
            str =
              ((obj.actual_width / 25.4) * dpi).toFixed(0) +
              ' * ' +
              ((((item.height * obj.actual_width) / 25.4) * dpi) / item.width).toFixed(0)
          }
        })
      }
      return str
    }
  },
  watch: {
    // selected(value) {
    //   const clipInfo = this.print_areas.filter((item, index) => item.view_id === value)
    //   this.clipSrc = clipInfo[0].image_src
    // },
    // bottom_images_template(value) {
    //   this.selected = value[0].view_id
    //   this.setActiveDesign(value[0].view_id)
    // }
    printImgInfo(val) {
      if (val.design_en_desc && val.design_desc_show === 1 && !this.$ls.get('designRemind')) {
        this.designDescVisible = true
        this.designDescIndex = 1
      } else {
        this.designDescVisible = false
        this.designDescIndex = 0
      }
    }
  },
  props: ['configData', 'fullscreen'],

  components: {
    CanvasComponent,
    SyncSide
  },
  created() {
    if (this.printImgInfo.design_en_desc && this.printImgInfo.design_desc_show === 1 && !this.$ls.get('designRemind')) {
      this.designDescVisible = true
      this.designDescIndex = 1
    } else {
      this.designDescVisible = false
      this.designDescIndex = 0
    }
  },
  mounted() {
    if (this.$ls.get('designRemind')) {
      this.noPrompt = true
    }
  },
  methods: {
    ...mapMutations({
      setActiveDesign: 'SET_ACTIVE_DESIGN',
      setRandom: 'SET_RANDOM',
      setSyncOtherSide: 'SET_SYNC_OTHER_SIDE',
      setTipLevel: 'SET_TIP_LEVEL',
      // 平铺数据
      setGroupCode: 'SET_GROUP_CODE',
      setGroupType: 'SET_GROUP_TYPE',
      setGroupPaddingX: 'SET_GROUP_PADDING_X',
      setGroupPaddingY: 'SET_GROUP_PADDING_Y',
      setGifVisible: 'SET_GIF_VISIBLE',
      resetFabricList: 'RESET_FABRIC_LIST',
      setHotKeys: 'SET_HOTKEYS',
      setActiveFabricListGruop: 'SET_ACTIVE_FABRIC_LIST_GRUOP',
      setCopyProductId: 'SET_COPY_PRODUCT_ID',
      setBackLoading: 'SET_BACK_LOADING'
    }),
    noPromptChange() {
      this.noPrompt = !this.noPrompt
      this.$ls.set('designRemind', this.noPrompt, 24 * 60 * 60 * 1000)
    },
    clickDesignDesc(val) {
      this.designDescIndex = val
    },
    visibleChange(val) {
      if (this.printImgInfo.design_en_desc) {
        this.designDescIndex = 1
      } else {
        this.designDescIndex = 0
      }
      this.designDescVisible = val
    },
    materialVisionMethod() {
      const { RightWrap } = this.$parent.$refs
      console.log('RightWrap===', RightWrap)
      RightWrap.materialVisionMethod(1)
    },
    canvasLoaded() {
      // 重新设计canvas 回调
      const { fabricList } = this
      getProductDesignInfo({ id: this.getCopyProductId }).then(res => {
        const { product_design } = res.data
        const product_designJson = JSON.parse(product_design)
        product_designJson.forEach(designJson => {
          const { view_id, design_params } = designJson
          const { canObj } = fabricList.find(item => item.view_id === view_id)
          canObj.loadFromJSON(design_params, () => {
            canObj.renderAll()
            this.setRandom()
          })
        })
      })
    },
    maskChange(pathString) {
      const t = this.activeFabric.getActiveObject()
      if (!t || t.type !== 'image') {
        this.$message.error('请选中图片再试')
        return
      }
      const { height, width } = t
      const path = new cc.Path(pathString, {
        originX: 'center',
        originY: 'center',
        left: 0,
        top: 0
      })
      const scaleX = width / path.width
      const scaleY = height / path.height
      path.scale(scaleX >= scaleY ? scaleY : scaleX)
      t &&
        t.set({
          clipPath: path
        })
      if (t && this.activeGroupInfo.code === t.time) {
        this.createGroupImgEntry(this.activeGroupInfo.type)
      } else {
        const objects = this.activeFabric.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (t && group && group.time === t.time) {
          this.$parent.createGroupImgEntry(group.groupType)
        }
      }
      this.activeFabric.renderAll()
      this.setRandom()
      saveHistory()
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',')
      // 注意base64的最后面中括号和引号是不转译的
      var _arr = arr[1].substring(0, arr[1].length - 2)
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(_arr)
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    makeRandom() {
      return Math.random(0, 1)
    },

    scaleWithAngleFix(view_id, t) {
      const { width, height } = this.print_areas.find(item => item.view_id === view_id)
      const angleChange = (2 * Math.PI) / 360
      const x1 = Math.abs(Math.cos(t.angle * angleChange)) * width
      const x2 = Math.abs(Math.sin(t.angle * angleChange)) * width
      const scale = height / width
      const x3 = scale * x1
      const x4 = scale * x2
      const tHeight = t.height
      const tWidth = t.width
      const scaleWidth = (x1 + x4) / tWidth
      const scaleHeight = (x2 + x3) / tHeight
      t.set('originX', 'center')
      t.set('originY', 'center')
      t.set('scaleX', scaleWidth).setCoords()
      t.set('scaleY', scaleHeight).setCoords()
      t.set('left', 275).setCoords()
      t.set('top', 275).setCoords()
    },
    scaleSingleWithAngleFix(view_id, t) {
      const { width, height } = this.print_areas.find(item => item.view_id === view_id)
      console.log(width, height, 'width,height')
      console.log(t, 't')
      const angleChange = (2 * Math.PI) / 360
      console.log(angleChange, 'angleChange')
      const tHeight = t.height
      const tWidth = t.width
      if (tHeight >= tWidth) {
        const x1 = Math.abs(Math.cos(t.angle * angleChange)) * width
        const x2 = Math.abs(Math.sin(t.angle * angleChange)) * height
        return (x1 + x2) / tWidth
      } else {
        const x1 = Math.abs(Math.cos(t.angle * angleChange)) * height
        const x2 = Math.abs(Math.sin(t.angle * angleChange)) * width
        // console.log(x1 + x2, 'x1x2')
        console.log(x2, 'x2')
        console.log(x1, 'x1')
        return (x1 + x2) / tHeight
      }
    },
    changeSelect(view_id) {
      console.log('bottom_images_template===', this.bottom_images_template)

      console.log('fabricList===', this.fabricList)
      this.setSyncOtherSide(false)
      if (view_id === this.activeDesign) return
      this.setActiveDesign(view_id)
      this.$emit('upBackgroundColor')
    },

    createGroupImgEntry(type) {
      let t = this.activeFabric.getActiveObject()
      if (t && t.type !== 'image') {
        this.$message.warning('请选择图片后重试!')
        return
      }
      if (t) {
        if (t.type === 'activeSelection') {
          t = t.toGroup()
          t.set({
            originX: 'center',
            originY: 'center',
            time: new Date().getTime(),
            removed: true,
            centeredScaling: true
          }).setCoords()
        }
      } else {
        this.$message.warning('请至少选中一个对象!')
        return
      }
      this.setGroupType({ activeDesign: this.activeDesign, data: type })

      this.removeGroup()
      if (type !== 0) {
        t.set('paddingX', this.activeGroupInfo.paddingX)
        t.set('paddingY', this.activeGroupInfo.paddingY)
        t.set('groupType', this.activeGroupInfo.type)
        console.log(this.activeGroupInfo.paddingX)
        this.setGroupCode({ activeDesign: this.activeDesign, data: t.time })
        this.setBackLoading(true)
        t && this.createGroupImgMain(t, type)
      } else {
        this.setGroupCode({ activeDesign: this.activeDesign, data: '' })
        this.activeFabric.renderAll()
      }
    },

    async createGroupImgMain(t, type) {
      const group = new cc.Group([], {
        height: 2000,
        width: 2000,
        left: t.left,
        top: t.top,
        angle: t.angle,
        originX: 'center',
        originY: 'center',
        selectable: false,
        material_code: t.material_code,
        src: t.src,
        objectCaching: false,
        style: t.style,
        uuid: t.uuid,
        time: t.time,
        groupType: type,
        vision_oss_file_id: t.vision_oss_file_id || '',
        vision_type: t.vision_type
      })

      const realHeight = t.getScaledHeight()
      const realWidth = t.getScaledWidth()

      const scaleX = t.scaleX
      const scaleY = t.scaleY
      let numX = 0
      let numY = 0
      const time = type === 5 ? 2 : 1
      if (t.left > 275) {
        numX = Math.ceil(t.left / realWidth) * time
      } else {
        numX = Math.ceil((550 - t.left) / realWidth) * time
      }

      if (t.top > 275) {
        numY = Math.ceil(t.top / realHeight) * time
      } else {
        numY = Math.ceil((550 - t.top) / realHeight) * time
      }
      for (let i = 0; i <= numX; i++) {
        for (let j = 0; j <= numY; j++) {
          if (i === 0 && j === 0) {
            continue
          }
          if (i === 0) {
            await this.createImgItem(i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          } else if (j === 0) {
            await this.createImgItem(-i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          } else {
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(-i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(-i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          }
        }
      }
      const objects = this.activeFabric.getObjects()
      const index = objects.findIndex(item => item.time === t.time)
      this.activeFabric.add(group)
      // group.sendToBack()
      for (let i = 0; i < objects.length - index; i++) {
        group.sendBackwards()
      }
      setTimeout(() => {
        this.setBackLoading(false)
      }, 1000)
      this.activeFabric.renderAll()
      this.setRandom()
      saveHistory()
    },
    createImgItem(i, j, type, paddingX, paddingY, realHeight, realWidth, scaleX, scaleY, imgItem, group) {
      const _this = this
      let crossX = 0
      let crossY = 0
      if (type === 2) {
        crossX = Math.abs(j) % 2 === 0 ? 0 : realWidth / 2
      }
      if (type === 3) {
        crossY = Math.abs(i) % 2 === 0 ? 0 : realHeight / 2
      }
      if (type === 4) {
        scaleX = Math.abs(i) % 2 === 0 ? scaleX : -scaleX
        scaleY = Math.abs(j) % 2 === 0 ? scaleY : -scaleY
      }
      let rand = 0
      let randScale = 1
      if (type === 5) {
        rand = Math.random() < 0.5 ? -1 : 1
        randScale = Math.random() * 0.5 + 0.5
      }

      // eslint-disable-next-line promise/param-names
      return new Promise(res => {
        imgItem.clone(img => {
          img.set({
            left: i * (realWidth / (type === 5 ? 2 : 1) - 1 + (_this.activeGroupInfo.paddingX || 0)) + crossX,
            top: j * (realHeight / (type === 5 ? 2 : 1) - 1 + (_this.activeGroupInfo.paddingY || 0)) + crossY,
            angle: rand * 30 * randScale,
            scaleX: scaleX * randScale,
            scaleY: scaleY * randScale,
            material_code: imgItem.material_code
          })

          group.add(img)
          res()
        })
        // 优化平铺实现速度
        // const img = imgItem.getElement()
        // img.set({
        //   left: i * (realWidth - 1 + _this.activeGroupInfo.paddingX) + crossX,
        //   top: j * (realHeight - 1 + _this.activeGroupInfo.paddingY) + crossY,
        //   angle: 0,
        //   scaleX,
        //   scaleY,
        //   material_code: imgItem.material_code
        // })
        // group.add(img)
        // res()
      })
    },
    removeGroup() {
      const objects = this.activeFabric.getObjects()
      objects.map(item => {
        if (item.type === 'group' && !item.removed) {
          this.activeFabric.remove(item)
        }
      })
    },
    createOtherSidesGroup() {},
    recordFn(bl) {
      this.recordTrue = !this.recordTrue
      if (this.recordTrue) {
        this.getOpenMaterialMethod({ per_page: 6, page: 1 })
      }
    },
    getOpenMaterialMethod(params) {
      getOpenMaterial(params).then(res => {
        this.recordTrue = true
        console.log('res====111', res)
        this.imgList = res.data.data
        this.searchCondition = {
          total: res.data.total && res.data.total > 30 ? 30 : res.data.total || 0,
          per_page: 6,
          page: res.data.current_page ? res.data.current_page : 1
        }
        console.log('searchCondition====111', this.searchCondition)
      })
    },
    copyFn() {
      var clipboard = new Clipboard('.tag-read')
      console.log('clipboard===', clipboard)
      clipboard.on('success', e => {
        this.$message.success(this.$t('design.copySuccessful'))
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.error(this.$t('design.notAllowCopy'))
        // 释放内存
        clipboard.destroy()
      })
    },
    copyProduct(record) {
      getProductDesignInfo({ id: record.id }).then(res => {
        const { product_design } = res.data
        this.setActiveFabricListGruop(
          JSON.parse(product_design).map((item, index) => {
            return {
              canObj: item.design_params,
              index,
              view_id: item.view_id
            }
          })
        )
        this.setCopyProductId(record.id)
        this.$emit('design', record.basic_product_id)
      })
    },
    saveHistoryFu() {
      saveHistory()
    },
    regainFn() {
      const _this = this
      this.$confirm({
        title: this.$t('generic.warning'),
        content: this.$t('design.restoreKeyWarning'),
        okText: this.$t('generic.yes'),
        okType: 'danger',
        cancelText: this.$t('generic.cancel'),
        onOk() {
          setUserHotKeys({ hotKeys: [] }).then(res => {
            _this.isEdit = false
            getUserHotKeys().then(res => {
              _this.setHotKeys(res.data.hotKeys || [])
              _this.$parent.hotkeys.unbind()
              _this.$parent.bindShortcut()
              this.hotKeyVisible = false
            })
          })
        }
      })
    },
    getValue(e, value) {
      e.preventDefault()
      // value.enName
      if (e.keyCode === 16 || e.keyCode === 17 || e.keyCode === 18) {
        this.groupKey = e.keyCode
      } else {
        if (this.groupKey) {
          value.enName = `${keyCodeData[this.groupKey]} + ${keyCodeData[e.keyCode > 123 ? '999' : e.keyCode]}`
        } else {
          value.enName = `${keyCodeData[e.keyCode > 123 ? '999' : e.keyCode]}`
        }
      }
    },
    keyupFn(e) {
      if (e.keyCode === 16 || e.keyCode === 17 || e.keyCode === 18) {
        this.groupKey = ''
      }
      this.isTrue = false
      this.enName = ''
      const arr = []

      this.hotKeys.forEach(item => {
        if (arr.indexOf(item.enName) === -1) {
          arr.push(item.enName)
        } else {
          this.enName = item.enName
          this.isTrue = true
        }
      })
      if (this.isTrue) {
        this.$message.error(
          this.$t('design.saveShortcutKeys_before') + this.enName + this.$t('design.saveShortcutKeys_after'),
          2
        )
      }
    },
    focusFn(item) {
      this.currKey = { ...item }
      item.enName = ''
      this.groupKey = ''
    },
    blurFn(item) {
      if (!item.enName) {
        item.enName = this.currKey.enName
      }
    },
    editSave() {
      if (this.isTrue) {
        this.$message.error(
          this.$t('design.saveShortcutKeys_before') + this.enName + this.$t('design.saveShortcutKeys_after'),
          2
        )
        return
      }
      setUserHotKeys({ hotKeys: this.hotKeys }).then(res => {
        this.$parent.hotkeys.unbind()
        this.$parent.bindShortcut()
        this.isEdit = false
        this.hotKeyVisible = false
      })
    },
    editCancel() {
      this.isEdit = false
      getUserHotKeys().then(res => {
        this.setHotKeys(res.data.hotKeys || [])
        this.hotKeyVisible = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.middleWrap {
  position: relative;
  flex: auto;
  display: flex;
  align-items: center;
  padding: 2px;
  .toolbar {
    width: 100%;
    position: absolute;
    background: #eeeeee;
    padding: 5px;
    border-radius: 2px;
    top: 0px;
    display: flex;
    justify-content: center;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .spItem {
      position: relative;
      font-size: 14px;
      color: #666;
      &.ml20 {
        margin-left: 20px;
      }
      &.ml30 {
        margin-left: 20px;
      }
      &.ml80 {
        margin-left: 80px;
      }
      &.pointer {
        cursor: pointer;
      }
      .recordBg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
      }
      .recordWrap {
        // display: none;
        visibility: hidden;
        position: absolute;
        top: 100%;
        left: 50%;
        width: 350px;
        padding: 20px;
        margin-left: -175px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        z-index: 99;
        &.hover {
          // display: block;
          visibility: visible;
        }
      }
      .rdTop {
        display: flex;
        justify-content: space-between;
        span {
          font-size: 12px;
          color: #666;
        }
      }
      .rdBody {
        margin: 0 -10px;
        .rdItem {
          position: relative;
          float: left;
          width: 90px;
          height: 90px;
          margin: 10px 10px 0 10px;
          background: #000;
          h5 {
            visibility: hidden;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            margin: 0;
            font-size: 14px;
            color: #fff;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
          }
          &:hover {
            h5 {
              visibility: visible;
            }
          }
        }
      }
      .contentWrap {
        overflow-y: auto;
        height: calc(100vh - 240px);
        width: 432px;
        .contentBox {
          /deep/img {
            max-width: 100%;
          }
        }

        .instruTitle {
          font-size: 18px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
          margin-bottom: 12px;
          span {
            display: inline-block;
            line-height: 32px;
            cursor: pointer;
            border-bottom: 2px solid transparent;
            &:first-child {
              margin-right: 020px;
            }
            &.on {
              color: #ffa200;
              font-weight: bold;
              border-bottom: 2px solid #ffa200;
            }
          }
        }
        .instruTit {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
          margin-bottom: 10px;
        }
        .instruP {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          margin-bottom: 10px;
        }
        &::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          // -webkit-box-shadow: inset 0 0 5px rgba(6, 6, 13, 0.2);
          background: rgba(6, 6, 13, 0.2);
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          border-radius: 10px;
          background: white;
        }
      }
      .tipsWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
      }
    }
    .lineSp {
      width: 1px;
      height: 30px;
      margin: 0 20px;
      background: #eeeeee;
    }
  }
  .img_level {
    position: absolute;
    padding: 5px;
    border-radius: 2px;
    top: 40px;
    right: 20px;
    display: flex;
  }
  .canvasWrap {
    height: 700px;
    width: 700px;
    position: relative;
    // background: #fff;
    // background-image: url('../../../assets/back.png');
    .clipImg {
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
    }
  }
  .controls {
    height: 50px;
    width: 550px;
    margin-top: 10px;
    background: #f0f0f0;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > i {
      font-size: 18px;
      cursor: pointer;
    }
  }
  .groupStyle {
    height: 60px;
    width: 550px;

    display: flex;
    align-items: center;
    padding: 0 16px;
    overflow: hidden;
    span {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .ant-slider {
      margin: 0;
      margin-top: 4px;
    }
    img {
      border: 2px solid white;
      border-radius: 2px;
      &:hover {
        cursor: pointer;
      }
    }
    .imgStyleContent {
      border: 2px solid #4c9be0;
    }
  }
  .imgStyle {
    height: 60px;
    width: 550px;

    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: space-between;
    overflow: hidden;
    span {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    img {
      border: 2px solid white;
      border-radius: 2px;
      &:hover {
        cursor: pointer;
      }
    }
    .imgStyleContent {
      border: 2px solid #4c9be0;
    }
  }
  .maskStyle {
    height: 60px;
    width: 550px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin: 0 auto;
    justify-content: space-between;
    overflow: hidden;
  }
  .imgStyleClose {
    height: 0px;
    overflow: hidden;
  }
  .select {
    height: 95px;
    width: 550px;
    white-space: nowrap;
    .imgItem {
      height: 48px;
      width: 48px;
      border-radius: 5px;
      overflow: hidden;
      margin-left: 10px;
      // float: left;
      box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);

      transition: all 0.1s;
      position: relative;
      top: 0;
      display: inline-block;
      &:hover {
        cursor: pointer;
        border-color: #4b9bdf;
      }
      .xs-box {
        position: absolute;
        bottom: 2px;
        right: 2px;
        .tips {
          margin-left: 3px;
          border-radius: 50%;
          display: block;
          height: 8px;
          width: 8px;
          border: 1px solid #ddd;
        }
      }
    }
    .imgItemActive {
      border: 2px solid #4c9be0;
    }
  }
  .middleMain {
    position: relative;
    margin: 0 auto;
    width: 700px;
    min-height: 700px;
    z-index: 9;
    .gifWrap {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      background: #fff;
      z-index: 99;
    }
    .tip {
      margin-bottom: 10px;
      color: #ff0000;
      line-height: 1;
      text-align: center;
      .tipSpan {
        display: inline-block;
        padding: 6px 40px;
        border-radius: 10px;
        border: 1px solid #d7bfbf;
        color: #333;
        background: #fff1f0;
        a {
          margin-left: 12px;
          text-decoration: underline;
        }
        .red {
          color: #ff0000;
        }
      }
      #tipForImg {
        display: inline-block;
        color: white;
        // rgb(245, 207, 82)
        // rgb(255, 153, 2)
        border-radius: 2px;
        font-size: 12px;
        z-index: 99;
        padding: 4px 20px;
      }
    }
    .selectPop {
      position: absolute;
      top: 20px;
      left: -110px;
      width: 100px;
      bottom: 10px;
      z-index: 9;
      .sideBox {
        position: relative;
        width: 80px;
        height: 32px;
        margin-left: 10px;
        margin-bottom: 10px;
        line-height: 32px;
        background: #ffffff;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
      }
      .imgItem {
        margin-bottom: 10px;
        margin-left: 10px;
        width: 80px;
        overflow: hidden;
        height: 80px;
        border: 1px solid transparent;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        cursor: pointer;
        &.imgItemActive {
          border: 1px solid #3699ff;
        }
      }
    }
  }
}
.hotKeyModal {
  margin: 0 -24px;

  .hotKeyItem {
    padding: 0 20px 20px;
    h5 {
      height: 40px;
      padding: 0 20px;
      font-size: 16px;
      color: #666;
      line-height: 40px;
      background: #f3f9ff;
    }
    .hotKeyBody {
      .bdItem {
        float: left;
        padding: 6px 20px;
        width: 33.33%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid #d9d9d9;
        &.br0 {
          border: none;
        }
      }
    }
  }
  .footer-btn {
    padding: 20px 20px 0 20px;
    border-top: 1px solid #d9d9d9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .mr20 {
      margin-right: 20px;
    }
  }
}
@media screen and (max-width: 1780px) {
  .middleWrap {
    .canvasWrap {
      width: 550px;
      height: 550px;
    }
    .middleMain {
      width: 550px;
      min-height: 550px;
    }
  }
}
</style>
